<script setup lang="ts">
import { DotLottieVue } from '@lottiefiles/dotlottie-vue'
</script>

<template>
  <DotLottieVue
    class="w-96 h-96"
    autoplay
    loop
    src="https://lottie.host/015ad31a-47b9-4b8c-9cee-36f722436662/VuAQ8TMMp3.lottie"
  />
</template>
